import { render, staticRenderFns } from "./questionnairPreview.vue?vue&type=template&id=6b236022&scoped=true&"
import script from "./questionnairPreview.vue?vue&type=script&lang=js&"
export * from "./questionnairPreview.vue?vue&type=script&lang=js&"
import style0 from "./questionnairPreview.vue?vue&type=style&index=0&id=6b236022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b236022",
  null
  
)

export default component.exports